<template>
    <span class="d-inline-flex align-center ml-1">
        <v-btn :disabled="loading" :loading="loading" color="primary" size="x-small" variant="text"
               @click="view">View receipt</v-btn>
        <span v-if="failed" class="text-caption text-error ml-1 receipt-unavailable" role="alert">Receipt unavailable</span>
        <v-dialog v-model="open" max-width="720">
            <v-card>
                <v-card-title>Receipt</v-card-title>
                <v-card-text>
                    <v-img v-if="url" :src="url" alt="Receipt" max-height="70vh" @error="onImageError"/>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="open = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script setup>
import {onBeforeUnmount, ref, watch} from "vue";
import {send} from "@/composables/apiClient";

// Fetched with the session token, so a plain link cannot show it.
const props = defineProps({
    endpoint: {type: String, required: true},
});

const url = ref("");
const open = ref(false);
const loading = ref(false);
const failed = ref(false);
let seq = 0;

const free = () => {
    if (url.value) URL.revokeObjectURL(url.value);
    url.value = "";
};

const view = async () => {
    const mine = ++seq;
    free();
    failed.value = false;
    loading.value = true;
    try {
        const res = await send("get", props.endpoint, null, {responseType: "blob"});
        if (mine !== seq) return;
        const blob = res.data;
        // An error page answered with a 200 is not a receipt
        if (!blob?.size || /json|html/i.test(blob.type)) throw new Error("not a file");
        url.value = URL.createObjectURL(blob);
        open.value = true;
    } catch {
        if (mine === seq) failed.value = true;
    } finally {
        if (mine === seq) loading.value = false;
    }
};

const onImageError = () => {
    open.value = false;
    failed.value = true;
};

watch(open, (isOpen) => {
    if (!isOpen && !failed.value) free();
});

// The table keys its rows by index, so a page change reuses this button for another record
watch(() => props.endpoint, () => {
    seq++;
    free();
    open.value = false;
    loading.value = false;
    failed.value = false;
});

onBeforeUnmount(() => {
    seq++;
    free();
});
</script>
